import { TOnboardingTabStatus } from "../../components/Front/Simple/FrontOnboardingTab/FrontOnboardingTab";
import { TClientCaseIdentityVerificationUserForm } from "../../../../domain/codecs/form/ClientCaseForm";
import { RequiresIdCheck, TUserCaseUserType } from "../../../../domain/codecs/UserCaseUserType";
import { requireExhaustive } from "../../../../shared/src/util";

export const isUsersIdentityVerified = (form: TClientCaseIdentityVerificationUserForm): boolean => {
    switch (form.children.user14.identity_verification_status) {
        case "not_complete":
        case "failed":
        case "expired":
        case "needs_address_document":
            return false;
        case "complete":
        case "pending":
            return true;
        default:
            return requireExhaustive(form.children.user14.identity_verification_status);
    }
};

export const getIdentityVerificationStepStatus = (
    users: Array<TClientCaseIdentityVerificationUserForm>,
    sessionUserId: string,
    sessionUserType: TUserCaseUserType,
): TOnboardingTabStatus => {
    if (users.length === 0) {
        return "completed";
    }

    const ownCards = users.filter((form) => form.children.user14.id === sessionUserId);

    const gatingUsers =
        RequiresIdCheck.includes(sessionUserType) && ownCards.length > 0
            ? ownCards
            : users;

    return gatingUsers.every(isUsersIdentityVerified) ? "completed" : "active";
};

export const hasOutstandingIdentityVerificationForOthers = (
    users: Array<TClientCaseIdentityVerificationUserForm>,
    sessionUserId: string,
    sessionUserType: TUserCaseUserType,
): boolean =>
    getIdentityVerificationStepStatus(users, sessionUserId, sessionUserType) === "completed"
    && users.some((form) =>
        form.children.user14.id !== sessionUserId
        && !isUsersIdentityVerified(form)
    );
